import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { useAuth } from "./AuthContext";
import { getWishlist, addWishlist, removeWishlist } from "../lib/api";

const WishlistContext = createContext();
export const useWishlist = () => useContext(WishlistContext);

export const WishlistProvider = ({ children }) => {
  const { user } = useAuth();
  const [ids, setIds] = useState([]);

  const load = useCallback(async () => {
    if (!user) {
      setIds([]);
      return;
    }
    try {
      const res = await getWishlist();
      setIds(res.product_ids || []);
    } catch {
      setIds([]);
    }
  }, [user]);

  useEffect(() => {
    load();
  }, [load]);

  const isFav = (productId) => ids.includes(productId);

  const toggle = async (productId) => {
    if (!user) return { needLogin: true };
    const wasFav = ids.includes(productId);
    // optimistic
    setIds((prev) => (wasFav ? prev.filter((i) => i !== productId) : [...prev, productId]));
    try {
      const res = wasFav ? await removeWishlist(productId) : await addWishlist(productId);
      setIds(res.product_ids || []);
    } catch {
      load(); // revert on error
    }
    return { needLogin: false, added: !wasFav };
  };

  return (
    <WishlistContext.Provider value={{ ids, isFav, toggle, reload: load, count: ids.length }}>
      {children}
    </WishlistContext.Provider>
  );
};
